import {
  UM_APP_NAME_DEV,
  UM_APP_NAME_PROD,
  URL_API_DEV,
  URL_API_LOCAL,
  URL_API_OVERRIDE,
  URL_API_PROD,
} from "./constants";

const getBaseUrl = () => {
  const hostname = window.location.hostname;

  // if there is an override api url set, use that
  if (URL_API_OVERRIDE) return URL_API_OVERRIDE;

  // production
  if (hostname.includes("prod")) return URL_API_PROD;

  // dev
  if (hostname.includes("dev")) return URL_API_DEV;

  // For any other environment (i.e. localhost)
  // we will assume api is running locally
  return URL_API_LOCAL;
};

const getAppName = () => {
  const hostname = window.location.hostname;

  //Determine the User Management application name.  This will be used
  //to request the user permissions for the application from User Mamangement API
  //NOTE: This name must exactly match the name the application is registered under
  //in the User Management application.

  // production
  if (hostname.includes("prod")) return UM_APP_NAME_PROD;

  // development
  if (hostname.includes("dev")) return UM_APP_NAME_DEV;

  // For any other environment (i.e. localhost) we will use DEV environment permissions
  return UM_APP_NAME_DEV;
};

export const appName = getAppName();
export const baseUrl = getBaseUrl();
